import { createFileRoute } from '@tanstack/react-router';

import CompanyDocuments from '@/modules/documents/pages/company-documents';

export const Route = createFileRoute('/_authenticated/_system/documents/')({
  head: () => ({
    meta: [{ title: 'Documentos da Empresa' }],
  }),
  component: CompanyDocuments,
});
